import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import './css/Contact.css'
const Contact = () => {
  return (
    <div className='contact' >
      <div className="info-box">
        <h2>Contact Us</h2>
        <p><FontAwesomeIcon className='contact-icon' icon={faEnvelope} /> sonicwavesmumbai@gmail.com</p>
        <p><FontAwesomeIcon className='contact-icon' icon={faPhone} /> +91 8390030091</p>
        <p><FontAwesomeIcon className='contact-icon' icon={faLocationDot} /> Mumbai,Maharashtra</p>
      </div>
      <div className="form-box">
        <div className="form-box-template">
          <h1>Get in Touch</h1>
          <form action="">
            <input type="text" placeholder='Your name' name='name' />
            <input type="email" placeholder='Your email' name='email' />
            <textarea rows={10} cols={55} name="Your query" ></textarea>
          </form>
          <button className='contact-btn' >SEND</button>
        </div>
      </div>
    </div>
  )
}

export default Contact